module.exports = __webpack_public_path__ + "static/05-ea67eff82bbb65f5e5f0e6d09a0596c8.jpg";